module.exports = __webpack_public_path__ + "static/media/iphone_screen9.ecc63ca9.png";